import { apiUtils } from "../../../utils/apiUtils";
import type { Organization, OrganizationListResponse, OrganizationPayload, OrganizationType } from "../types/organization.types";

const endpoint = "/v1/organizations";

function toOrganizationFormData(payload: OrganizationPayload) {
  const formData = new FormData();
  formData.append("name", payload.name);

  if (payload.organization_type) formData.append("organization_type", payload.organization_type);
  if (payload.state) formData.append("state", payload.state);
  if (payload.image) formData.append("image", payload.image);
  if (payload.boundary_geojson) formData.append("boundary_geojson", payload.boundary_geojson);

  const mapFields = [
    "map_center_latitude",
    "map_center_longitude",
    "map_max_bounds_south_latitude",
    "map_max_bounds_west_longitude",
    "map_max_bounds_north_latitude",
    "map_max_bounds_east_longitude",
    "map_zoom",
  ] as const;

  mapFields.forEach((field) => {
    const value = payload[field];
    if (value !== undefined) formData.append(field, String(value));
  });

  return formData;
}

export function getOrganizations(params: {
  index: number;
  size: number;
  keyword?: string;
  organization_type?: OrganizationType;
}) {
  return apiUtils.getData<OrganizationListResponse>(endpoint, "Failed to load organizations", { params });
}

export async function createOrganization(payload: OrganizationPayload) {
  return apiUtils.unwrap(
    await apiUtils.postWithFormData<Organization>(endpoint, toOrganizationFormData(payload)),
    "Failed to create organization",
  );
}

export async function updateOrganization(id: string, payload: OrganizationPayload) {
  return apiUtils.unwrap(
    await apiUtils.putWithFormData<Organization>(`${endpoint}/${id}`, toOrganizationFormData(payload)),
    "Failed to update organization",
  );
}

export async function deleteOrganization(id: string) {
  return apiUtils.unwrap(await apiUtils.delete<Organization>(`${endpoint}/${id}`), "Failed to delete organization");
}
